/**
 * 文をつなぐときの句点の決まり（総点検 J-32・J-60）。
 *
 * サーバから返る理由の文は「。」で終わるものと終わらないものが混ざっています。
 * 「作れませんでした（名前を入力してください。）。」のように、かっこで包んだうえに句点を
 * 付けると「。）。」と重なるので、**かっこで包まず、理由を次の文として続けます**。
 */

/** 文の終わりに句点が無ければ付ける（「？」「！」で終わる文はそのまま）。 */
export function sentence(text: string): string {
  const trimmed = text.trim();
  if (trimmed === '') return '';
  return /[。！？!?]$/.test(trimmed) ? trimmed : `${trimmed}。`;
}

/** 「〜できませんでした。」のあとに理由の文を続ける。 */
export function withReason(head: string, reason: string): string {
  return `${sentence(head)}${sentence(reason)}`;
}

/**
 * 理由の文そのものが、次にしていただくことで終わっているか（「…から始めてください。」
 * 「…一覧を開き直してください。」など）。
 *
 * そのときは画面の側で決まり文句（「入力の内容をご確認のうえ…」など）を後ろに足さない。
 * 足すと、言っていることが食い違う・同じお願いが2回続く（#367 U-5・#334 L-1 と同じ系統）。
 */
export function endsWithRequest(reason: string): boolean {
  return /(ください|お願いします)[。．]?$/.test(reason.trim());
}
